import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class LoadingService extends Service {
  @tracked isLanguageLoading: boolean = false;

  startLanguageLoad() {
    this.isLanguageLoading = true;
  }

  stopLanguageLoad() {
    this.isLanguageLoading = false;
  }
}

